var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"envio-validacao"},[_c('div',{staticClass:"coming-soon"},[_c('i',{staticClass:"fas fa-check-circle"}),_c('h2',[_vm._v("Validação de Envio")]),_c('p',[_vm._v("Esta funcionalidade está sendo implementada.")])])])
}]

export { render, staticRenderFns }